import { applyService } from "@/service"
import ActionId from "@/action/ActionId"
import Action from "@/action/Action"
import { goto } from "@/util/navigation"
import FinishType from "@/model/apply/FinishType"
import store from "@/store"
import { applicationState, sessionState } from "@/state"

class FinishApplyAction extends Action {

    #finishAction = null

    constructor(finishAction) {
        super(ActionId.FINISH_APPLY)
        this.#finishAction = finishAction
    }

    async invoke() {
        try {
            switch (this.#finishAction) {
                case FinishType.TIMEOUT:
                    await applyService.finishTimeout()
                    break
                case FinishType.CANCEL:
                    await applyService.finishCanceled()
                    break
                case FinishType.PENDING:
                    await applyService.finishPending()
                    break
                default:
                    await applyService.finishCompleted()
            }
        } catch (e) {
            console.log("Error finishing apply", e)
        } finally {
            applicationState.application = {}
            const previousSession = { ...sessionState.session || {} }
            const newSession = {
                experienceType: sessionState.session.experienceType,
                groupId: sessionState.session.groupId,
            }
            store.commit("clearStorage")
            sessionState.session = newSession
            sessionState.previousSession = previousSession

            await goto({ path: `/finish/${this.#finishAction}` })
        }
    }
}

export default FinishApplyAction
